<form class="statement-form" [formGroup]="formFamiliar" (ngSubmit)="adicionarFamiliar()" *ngIf="tipoCargo == 2">
  <h4>{{titulo}}</h4>
  <section class="pl-0 form-pessoa-politica">
    <div class="col-xl-3 px-2">
      <label class="label-form">Seu Nome</label>
      <input class="form-control input-form" placeholder="Informe seu nome" formControlName="name" />
    </div>
    <div class="col-xl-2 px-2 py-1">
      <label class="content__form__title__label">Grau de parentesco</label>
      <ng-select [items]="familyGroupTypes" bindLabel="value" bindValue="key" placeholder="" [searchable]="false"
        formControlName="familyGroupTypeId" [placeholder]="'Selecione'">
      </ng-select>
    </div>
    <div class="col-xl-2 px-2">
      <label class="label-form">Cargo</label>
      <input class="form-control input-form" formControlName="exposedPersonPositionId" placeholder="Clique aqui"
        id="inputField" (click)="openModal(2)" #inputField />
    </div>
    <div class="col-xl-2 px-2">
      <label class="label-form">Data de Entrada</label>
      <input type="date" class="form-control input-form" formControlName="initialDate" [max]="todaysDate" />
    </div>
    <div class="col-xl-2 px-2">
      <label class="label-form">Data de Saída</label>
      <input type="date" class="form-control input-form" formControlName="finalDate" />
    </div>
    <div class="col-xl-1 px-2 content-button-form-cargo">
      <button type="submit" class="btn btn-primary" [disabled]="this.formFamiliar.invalid">
        Adicionar
      </button>
    </div>
  </section>
</form>
<form class="statement-form" [formGroup]="form" (ngSubmit)="adicionar()" *ngIf="tipoCargo == 1 || tipoCargo == 3">
  <h4>{{titulo}}</h4>
  <section class="pl-0 form-pessoa-politica">
    <div class="col-xl-4 px-2">
      <label class="label-form">Seu Nome</label>
      <input class="form-control input-form" placeholder="Informe seu nome" formControlName="name" />
    </div>
    <div class="col-xl-3 px-2">
      <label class="label-form">Cargo</label>
      <input class="form-control input-form" formControlName="exposedPersonPositionId" placeholder="Clique aqui"
        id="inputField" (click)="openModal(1)" #inputField />
    </div>
    <div class="col-xl-2 px-2">
      <label class="label-form">Data de Entrada</label>
      <input type="date" class="form-control input-form" formControlName="initialDate" [max]="todaysDate" />
    </div>
    <div class="col-xl-2 px-2">
      <label class="label-form">Data de Saída</label>
      <input type="date" class="form-control input-form" formControlName="finalDate" />
    </div>
    <div class="col-xl-1 px-2 content-button-form-cargo">
      <button type="submit" class="btn btn-primary" [disabled]="this.form.invalid">
        Adicionar
      </button>
    </div>
  </section>
</form>
